// Full-document render of the tempurpedic HomePage: PageSkeleton (the React
// document shell) wrapping the home layout (normal site chrome). Composes the
// two existing home island bodies plus the rewards-ad-bar partial.
//
// data-template ANCHOR (load-bearing): home.scss keys
// `[data-track-event="HomePageView"] [data-template="HomeContentAssemblyTemplate"]
// > .l-full-width { overflow: hidden }`. The in-tree wrapper reproduces
// `data-template="HomeContentAssemblyTemplate"` so the component's
// `.l-full-width` stays a direct child and the rule keeps matching (the
// body's data-track-event="HomePageView" comes from page_chrome.event_name).
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { HomeContentAssembly } from "../components/HomeContentAssembly";
import { HomePageBody } from "../components/HomePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

type IProps = Immutable<templates.HomePageTemplate>;

// RewardsAdBar renders only when PromoSettings.promo_bar has `promo` blocks
// (the builder returns one item per block). Each promo renders desktop +
// mobile rich-text copy.
const RewardsAdBar = (
    props: Immutable<{ items: IProps["rewards_ad_items"] }>,
): React.JSX.Element | null => {
    if (props.items.length === 0) {
        return null;
    }
    return (
        <div className="rewards-ad-bar l-full-width">
            <div className="rewards-ad l-capped-width">
                {props.items.map((item, i) => (
                    <React.Fragment key={i}>
                        <div
                            className="rewards-ad__content"
                            dangerouslySetInnerHTML={{ __html: item.copy_html }}
                        />
                        <div
                            className="rewards-ad__content rewards-ad__content--mobile"
                            dangerouslySetInnerHTML={{
                                __html: item.mobile_copy_html,
                            }}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export const Template = (props: IProps): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div data-template="HomeContentAssemblyTemplate">
            <HomeContentAssembly page={props.page} />
        </div>
        <HomePageBody
            page={props.page}
            hardcoded_ssr={props.hardcoded_ssr}
            hotspot_ssr={props.hotspot_ssr}
            breadcrumbs_ssr={props.breadcrumbs_ssr}
            customer_service_ssr={props.customer_service_ssr}
            shop_compare_ssr={props.shop_compare_ssr}
            tab_feature_attribute_ssr={props.tab_feature_attribute_ssr}
            reviews_ssr={props.reviews_ssr}
            reviews_url_ssr={props.reviews_url_ssr}
            prequal_enabled_ssr={props.prequal_enabled_ssr}
        />
        <RewardsAdBar items={props.rewards_ad_items} />
    </PageSkeleton>
);
